import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PermissionGuard } from '@ruby/core/guards/permission.guard';
import { TransactionResolver } from '@ruby/core/resolvers/transaction.resolver';
import { GuaranteesGridContainer } from '@ruby/modules/guarantees/containers/guarantees-grid/guarantees-grid.container';
import { EAuthorization } from '@ruby/shared/enums/authorizations.enums';
import { EGuaranteesGridPaths } from '@ruby/shared/enums/guarantees.enum';

const routes: Routes = [
  {
    path: 'storage',
    component: GuaranteesGridContainer,
    resolve: { transaction: TransactionResolver },
    canActivate: [PermissionGuard],
    data: {
      authorizations: [EAuthorization.IM_STORAGE_VIEW],
      type: EGuaranteesGridPaths.STORAGE,
      skipTransaction: true
    }
  },
  {
    path: 'lift',
    component: GuaranteesGridContainer,
    resolve: { transaction: TransactionResolver },
    canActivate: [PermissionGuard],
    data: {
      authorizations: [EAuthorization.IM_LIFT_VIEW],
      type: EGuaranteesGridPaths.LIFT,
      skipTransaction: true
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GuaranteesRoutingModule {}
